import { CellContext, type RowData } from 'src/lib/tanstack-react-table';
import { NumberCellContent } from './NumberCell.content';

export const NumberCell = <TType extends RowData>({ getValue }: CellContext<TType, number>) => {
  const cellValue = getValue();

  return <NumberCellContent data={cellValue} />;
};
